module.exports = __webpack_public_path__ + "img/bien-logo.60d0ccd1.svg";